import { createFileRoute, redirect } from '@tanstack/react-router'
import Transliteration from 'pages/transliteration'
import { canonicalLink, pageMeta, translitAlternates, TRANSLIT_URL_EN } from 'lib/seo'

const TranslitTitle = 'Automatic Thai to English transliteration - fast, easy and accurate'
const TranslitDescription =
   'Free automatic Thai to English transliteration. Paste Thai script and get an easy-to-read romanization instantly.'

const TransliterationEn = () => <Transliteration lang="en" />

export const Route = createFileRoute('/transliteration')({
   validateSearch: (
      search: Record<string, unknown>
   ): {
      lang?: string
   } => {
      return {
         lang: (search.lang as string) || undefined,
      }
   },
   // The Thai variant used to live at ?lang=th but /ภาษาคาราโอเกะ is the URL
   // its canonical tag has always advertised, so it now renders there and the
   // legacy query-param form redirects rather than serving a duplicate.
   beforeLoad: ({ search }) => {
      if (search.lang === 'th') throw redirect({ to: '/ภาษาคาราโอเกะ' })
   },
   head: () => ({
      meta: pageMeta({
         title: TranslitTitle,
         description: TranslitDescription,
         url: TRANSLIT_URL_EN,
      }),
      links: [canonicalLink(TRANSLIT_URL_EN), ...translitAlternates],
   }),
   component: TransliterationEn,
})
